<template>
  <TemplatePlateComp />
</template>

<script>
import TemplatePlateComp from "@/layouts/TemplatePlateComp.vue";

export default {
  name: "CarPlate",
  components: { TemplatePlateComp },
};
</script>
